import { VerifiableIdNumber } from "src/contexts/documentationArea/domain/VerifiableIdNumber";

export type ActorIdentityRepresentativeProps = {
  email: string | null;
  name: string | null;
  firstSurname: string | null;
  secondSurname: string | null;
  idNumbers: VerifiableIdNumber[];
};

export class ActorIdentityRepresentative {
  private readonly email: string | null;
  private readonly name: string | null;
  private readonly firstSurname: string | null;
  private readonly secondSurname: string | null;
  private readonly idNumbers: VerifiableIdNumber[];

  constructor({
    email,
    name,
    firstSurname,
    secondSurname,
    idNumbers = [],
  }: ActorIdentityRepresentativeProps) {
    this.email = email ?? null;
    this.name = name ?? null;
    this.firstSurname = firstSurname ?? null;
    this.secondSurname = secondSurname ?? null;
    this.idNumbers = idNumbers || [];
  }

  public hasName() {
    return this.hasValue(this.name);
  }

  public hasFirstSurname() {
    return this.hasValue(this.firstSurname);
  }

  public hasSecondSurname() {
    return this.hasValue(this.secondSurname);
  }

  private hasValue(value?: string | null): boolean {
    return value !== null && value !== undefined && value.length > 0;
  }

  public getEmail(): string | null {
    return this.email;
  }

  public getName(): string | null {
    return this.name;
  }

  public getFirstSurname(): string | null {
    return this.firstSurname;
  }

  public getSecondSurname(): string | null {
    return this.secondSurname;
  }

  public getFullName(): string | null {
    const nameParts = [this.name, this.firstSurname, this.secondSurname].filter(
      (part) => part !== null && part !== undefined && part.length > 0,
    );
    return nameParts.length > 0 ? nameParts.join(" ") : null;
  }

  public hasIdNumber(): boolean {
    return this.idNumbers.length > 0;
  }

  public getIdNumber() {
    return this.idNumbers[0];
  }

  public getIdNumbers(): VerifiableIdNumber[] {
    return this.idNumbers;
  }
}
